module.exports = __webpack_public_path__ + "img/team-mobile-4.15f9e573.jpg";